import axios from 'axios';
import UserAuth from './userAuth';
import { OnboardingService } from '@webapp/preact-shared';

export default class HelpService {
    static getUrl = url => process.env.baseHref + url;
    static urlInstallerParameters = process.env.baseHref + '/api/device-compliance/v1/installer-parameters';

    static getHelpInfo() {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/online/v1/support/get-info')
        });
    }

    static submitSupportForm(data) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/online/v1/support/form'),
            data: data
        });
    }

    static getOnboardingAppDownloadParameters() {
        return axios.get(this.urlInstallerParameters+'?mode=onboarding');
    }

    static getUserInfo() {
        const companySettingPromise = UserAuth.getCompanySettings();
        const userSettingPromise = OnboardingService.getUserSettings();
        return Promise.all([companySettingPromise, userSettingPromise]);
    }
}




// WEBPACK FOOTER //
// ./src/scripts/services/helpService.js